import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M13.707 3.707 15 5V1h-4l1.293 1.293L9.295 5.29l1.414 1.415 2.998-2.998ZM9.02 11.866 4.134 6.98l2.094-2.093a.988.988 0 0 0 0-1.397C5.062 2.327 3.901 1.163 2.737 0L.285 2.455A.952.952 0 0 0 0 3.15c.093 3.51 1.474 6.753 3.785 9.064C6.101 14.529 9.35 15.907 12.85 16a.952.952 0 0 0 .696-.284L16 13.262l-3.49-3.49a.988.988 0 0 0-1.396 0L9.02 11.866Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconCommunicationOutgoingCall16 = createIcon(IconComponent);